// @flow
import * as React from 'react';
import Select from 'react-select';
import { sortByName } from '../helpers';

type Props = {
  focus?: any,
  value?: string | number | null,
  options: any,
  keys?: string[],
  onChange: Function,
  'aria-label'?: string
};

class SelectDropdown extends React.Component<Props> {
  selectInput: ?HTMLSelectElement;

  componentDidMount() {
    if (this.props.focus && this.selectInput) {
      this.selectInput.focus();
    }
  }

  render() {
    const {
      value,
      focus,
      options,
      onChange,
      keys = ['id', 'name'],
      ...rest
    } = this.props;
    const sortedOptions = sortByName(options, keys[1]);
    const formattedOptions = sortedOptions.map(item => ({
      value: item[keys[0]],
      label: item[keys[1]]
    }));
    return (
      <Select
        ref={node => (this.selectInput = node)}
        value={value}
        options={formattedOptions}
        onChange={item => {
          if (item) {
            onChange(item.value, item.label);
          }
        }}
        clearable={false}
        placeholder="Please Select"
        aria-label={this.props['aria-label']}
        inputProps={{
          'data-lpignore': 'true',
          ...rest
        }}
      />
    );
  }
}

export default SelectDropdown;



// WEBPACK FOOTER //
// ./src/components/SelectDropdown.js